import {createAction} from "@reduxjs/toolkit";
import {ProductPropertyData} from "../api/GovernanceToolApi";

export const updateLastSearchFilterAction =
    createAction('UpdateLastSearchFilter', function prepare(
        filterSearch: string,
        filterValues: { [category: string]: ProductPropertyData },
        filterReleaseType: 0 | 1 | undefined) {
        return {
            payload: {
                filterSearch,
                filterValues,
                filterReleaseType
            },
        }
    })